import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TICKETS_PATHS } from '../../../../../../tickets/tickets';
import { Enums } from '../../../../../../../configs/Enums';
import { TicketViewService } from '../../../../../../tickets/ticket-view/ticket-view.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-ticket-gp',
  templateUrl: './tickets-ticket-gp.component.html',
  styleUrls: ['./tickets-ticket-gp.component.scss'],
  standalone: false,
})
export class TicketsTicketGpComponent {
  TICKETS_PATHS = TICKETS_PATHS;
  Enums = Enums;
  isRefreshingLineStatus: boolean = false;

  @Input() ticket;
  @Input() ticketsCurrentFilter;
  @Input() filter;
  @Input() brigadeAssign;
  @Input() ticketsMultipleAssign;

  constructor(private ticketViewService: TicketViewService) {}

  refreshLineStatus(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    if (!this.ticket || !this.ticket.id || this.isRefreshingLineStatus) {
      return;
    }
    this.isRefreshingLineStatus = true;
    this.resolveTicketLogin().subscribe(
      (login: string) => {
        if (!login) {
          this.isRefreshingLineStatus = false;
          return;
        }
        this.ticketViewService.getHdAbonentStatus({ login }).subscribe(
          (response: any) => {
            this.isRefreshingLineStatus = false;
            if (response && response.data && response.data.status != null) {
              const code = Number(response.data.status);
              this.ticket.hd_line_status_info = [1, 2, 3, 4].indexOf(code) > -1 ? 1 : 0;
            } else {
              this.ticket.hd_line_status_info = null;
            }
          },
          () => {
            this.isRefreshingLineStatus = false;
          }
        );
      },
      () => {
        this.isRefreshingLineStatus = false;
      }
    );
  }

  private resolveTicketLogin() {
    if (this.ticket.ticket_login) {
      return of(this.ticket.ticket_login as string);
    }
    return this.ticketViewService.getTicket(this.ticket.id).pipe(
      map((res: any) => {
        const login = (res && res.data && res.data.ticket_login) || '';
        if (login) {
          this.ticket.ticket_login = login;
        }
        return login;
      })
    );
  }
}
